<template>
  <v-app id="login">
    <v-main>
      <v-container>
        <div class="login-logo">
          <img src="../assets/r-logo-dark.svg" alt="RClient">
        </div>
        <v-card class="login-card">
          <v-form @submit.prevent="login">
            <v-card-title>
              <div v-if="isError" class="error--text">Неверные электронная почта или пароль</div>
              <div v-else>Введите электронную почту и пароль</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                type="email"
                v-model="email"
                label="Email"
                outlined
                :error="isError"
              />
              <v-text-field
                type="password"
                v-model="password"
                label="Пароль"
                outlined
                :error="isError"
              />
              <v-btn
                type="submit"
                color="primary"
                x-large
                depressed
                block
              >Войти
              </v-btn>
            </v-card-text>
          </v-form>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import qs from 'qs';

  export default {
    name: "LoginPage",
    data() {
      return {
        email: '',
        password: '',

        errorTimeout: null,
        isError: false,
      }
    },
    methods: {
      login() {
        this.$auth.login({
          url: 'auth/login',
          data: qs.stringify({
            email: this.email,
            password: this.password,
          }),
          rememberMe: true,
          redirect: {name: 'clients.list'},
          fetchUser: true,
          error: () => {
            clearTimeout(this.errorTimeout);
            this.isError = true;
            this.errorTimeout = setTimeout(() => {
              this.isError = false;
            }, 5000);
          },
        });
      }
    }
  }
</script>

<style lang="scss">

  #login {

    .v-main__wrap {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      justify-content: center;
    }


    .login-logo {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;

      img {
        display: block;
        height: 50px;
      }
    }


    .login-card {
      max-width: 500px;
      margin: 0 auto 40px;


      .v-card__title {
        justify-content: center;
        text-align: center;
        font-size: 20px;
        line-height: 24px;
        padding: 30px 30px 0;

        .viewport-xs & {
          font-size: 14px;
          line-height: 20px;
          padding-left: 25px;
          padding-right: 25px;
        }
      }


      .v-card__text {
        padding: 30px;

        .viewport-xs & {
          padding-left: 25px;
          padding-right: 25px;
        }
      }
    }
  }
</style>
